import React from "react";

import Grid from "@mui/material/Grid";
import { CustomEventElements } from "@src/features/customEvents/components/CustomEventElements";
import { CustomEventPageTargetingWrapper } from "@src/features/customEvents/components/CustomEventPageTargetingWrapper";

interface ClickEventProps {
  isArchived: boolean;
}

export const ClickEvent = ({ isArchived }: ClickEventProps) => {
  return (
    <Grid container width={"100%"}>
      <CustomEventElements isArchived={isArchived} />
      <Grid marginTop={"20px"} width={"100%"}>
        <CustomEventPageTargetingWrapper
          buttonText={"Add a Page"}
          isArchived={isArchived}
          showHeader
        />
      </Grid>
    </Grid>
  );
};
